import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-collapse",
  "use": "icon-collapse-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"icon-collapse\"><path d=\"M11 22C4.925 22 0 17.075 0 11S4.925 0 11 0s11 4.925 11 11-4.925 11-11 11zm0-1.833a9.167 9.167 0 1 0 0-18.334 9.167 9.167 0 0 0 0 18.334zm2.019-6.153a.917.917 0 1 1-1.288 1.305l-3.667-3.618a.917.917 0 0 1-.008-1.296l3.667-3.716a.917.917 0 0 1 1.304 1.288l-3.022 3.063 3.014 2.974z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-collapse.svg
// module id = 870
// module chunks = 74